import type { ComparisonRow } from "@/lib/productContent";

export function ComparisonTable({ rows, productName }: { rows: ComparisonRow[]; productName: string }) {
  return (
    <section aria-labelledby="comparison-heading" className="mt-10 md:mt-16">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-brand">
          How it compares
        </p>
        <h2
          id="comparison-heading"
          className="mt-2 font-display text-3xl font-bold text-brand-deep md:text-4xl"
        >
          {productName} vs standard supplements
        </h2>
        <p className="mt-3 text-sm text-muted-foreground md:text-base">
          A side-by-side of what's actually in the bottle.
        </p>
      </div>
      <div className="mx-auto mt-8 max-w-3xl overflow-hidden rounded-2xl border border-border bg-card">
        <div className="grid grid-cols-[1.1fr_1.4fr_1.4fr] border-b border-border bg-brand-soft/60 text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-deep md:text-xs">
          <div className="px-3 py-3 md:px-5 md:py-4">Metric</div>
          <div className="px-3 py-3 text-brand md:px-5 md:py-4">TruWe</div>
          <div className="px-3 py-3 md:px-5 md:py-4">Standard</div>
        </div>
        <ul className="divide-y divide-border">
          {rows.map((r) => (
            <li
              key={r.metric}
              className="grid grid-cols-[1.1fr_1.4fr_1.4fr] items-start text-[12px] leading-relaxed md:text-sm"
            >
              <div className="px-3 py-3 font-semibold text-brand-deep md:px-5 md:py-4">{r.metric}</div>
              <div className="px-3 py-3 text-brand-deep md:px-5 md:py-4">{r.truwe}</div>
              <div className="px-3 py-3 text-muted-foreground md:px-5 md:py-4">{r.standard}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
